// Root route. Per TanStack Start latest:
// https://tanstack.com/start/latest/docs/framework/react/build-from-scratch
//
// HeadContent reads metadata from the route `head` option; Scripts injects
// the client bundle. Providers (Redux/QueryClient/i18n/Theme) wrap the tree
// rendered by <Outlet/>. Two shells coexist: GfoShell for the public site
// and AppShell for the admin section, selected by URL prefix. Once the
// admin section grows real routes we'll move to a pathless-layout-route
// pattern (_public.tsx / _admin.tsx) so the choice is structural rather
// than a runtime check; F4 keeps it light because there's only one demo
// admin route.
//
// No SSR loader: bearer-token auth lives in Redux/localStorage on the
// client. The root just renders; per-page guards (useRouteGuard or the
// SSR requireAuthFn for sensitive routes) handle gating downstream.

import { AppShell } from '@podium/platform/layouts'
import { HeadContent, Outlet, Scripts, createRootRoute, useLocation } from '@tanstack/react-router'

import { GfoShell } from '../components/gfo-shell'
import { Providers } from '../providers'

import type { ReactNode } from 'react'
import '../styles.css'

export const Route = createRootRoute({
  head: () => ({
    meta: [
      { charSet: 'utf-8' },
      { name: 'viewport', content: 'width=device-width, initial-scale=1' },
      { title: 'Годишни финансови отчети' },
    ],
  }),
  component: RootComponent,
})

function RootComponent() {
  return (
    <RootDocument>
      <Providers>
        <ShellSwitch />
      </Providers>
    </RootDocument>
  )
}

function ShellSwitch() {
  const { pathname } = useLocation()
  if (pathname.startsWith('/admin')) {
    return (
      <AppShell
        brand={<span>GFO Admin</span>}
        pageFooter={<span>Godishni-Otcheti — internal admin</span>}
      >
        <Outlet />
      </AppShell>
    )
  }
  return (
    <GfoShell>
      <Outlet />
    </GfoShell>
  )
}

function RootDocument({ children }: Readonly<{ children: ReactNode }>) {
  return (
    <html lang="bg">
      <head>
        <HeadContent />
      </head>
      <body>
        {children}
        <Scripts />
      </body>
    </html>
  )
}
